import React from 'react';

interface IPlusCertificateIconProps {
  color?: string;
}

const PlusCertificateIcon = (props: IPlusCertificateIconProps) => {
  const { color = '#B3B3B2' } = props;
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C8.5523 0 9 0.44772 9 1V7H15C15.5523 7 16 7.4477 16 8C16 8.5523 15.5523 9 15 9H9V15C9 15.5523 8.5523 16 8 16C7.4477 16 7 15.5523 7 15V9H1C0.44772 9 0 8.5523 0 8C0 7.4477 0.44772 7 1 7H7V1C7 0.44772 7.4477 0 8 0Z"
        fill={color}
      />
    </svg>
  );
};

export default PlusCertificateIcon;
